import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BackButtonIcon } from "../../../icons/academy-icons";
import Button from "../../common/button";
import { useGetMoneyTaxHomeDataQuery } from "../../../store/api/moneyApi";
import { toastError, toastSuccess } from "../../toast";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import LottieAnimation from "../../common/animations";
import { trackEvent } from "../../../analytics";

const FileITRPage = () => {
  const navigate = useNavigate();
  const [couponCode, setCouponCode] = useState("CTBONEPT");
  const { data } = useGetMoneyTaxHomeDataQuery();
  const isPageViewTracked = React.useRef(false);
  useEffect(() => {
    if (isPageViewTracked.current) return;
    trackEvent("cleartax_discount_page_opened", {});
    isPageViewTracked.current = true;
  }, []);
  useEffect(() => {
    if (data?.data?.file_tax?.coupon_code) {
      setCouponCode(data?.data?.file_tax?.coupon_code);
    }
  }, [data]);
  const handleCopyCode = () => {
    navigator.clipboard
      .writeText(couponCode)
      .then(() => {
        trackEvent("cleartax_discount_page_cta_clicked", {
          cta_for: "copy_code",
        });
        toastSuccess({ message: "Coupon code copied to clipboard" });
      })
      .catch(() => {
        toastError({ message: "Coupon code copied to clipboard" });
      });
  };

  return (
    <div className="flex-1">
      {/* Header */}
      <div className="">
        <div className="font-bold text-3xl flex gap-8 items-center px-6 pb-6">
          <Link to="/money/protect/tax">
            <BackButtonIcon width={20} height={20} />
          </Link>
          <p>File Your ITR</p>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 pb-6">
        <div className="bg-white rounded-lg shadow-sm px-8 pb-8">
          <div className="flex flex-col md:flex-row gap-8 item-center justify-center">
            {/* Left side - Steps */}
            <div className="flex-1 flex justify-center flex-col items-center mt-10">
              <h2 className="h-[62px] self-stretch flex-grow-0 font-SFPro text-[24px] font-bold normal-case leading-[1.3] tracking-[-0.08px] text-center text-[#090909] mx-10 mt-6">
                File your Income Tax Return in 3 simple steps
              </h2>

              <div className="max-w-md">
                <LottieAnimation
                  lottieUrl="/animation/cleartax.lottie"
                  height="280px"
                  width="280px"
                />
              </div>
            </div>

            {/* Right side - Coupon */}
            <div className="flex-1 flex items-center justify-center">
              <div className="relative">
                <div className="text-center relative">
                  <div className="absolute inset-0 z-0">
                    <img
                      src="/assets/money/tax/Grid 3x.png"
                      alt="Grid Background"
                      className="mx-auto w-full h-full object-cover opacity-40"
                    />
                  </div>
                  <div className="relative z-10">
                    <img
                      src="https://storage.onepercentclub.io/money/protect/Coupon+Container.png"
                      alt="Coupon Container"
                      className="h-full w-full"
                    />
                  </div>
                  <button
                    onClick={handleCopyCode}
                    className=" bg-gray-800 text-amber-100 py-2 px-4 rounded flex items-center gap-2 mx-auto transition-all hover:bg-gray-700 cursor-pointer z-20 relative"
                  >
                    <span>{couponCode}</span>
                    <CopyIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Continue Button */}
          <div className="mt-12 flex justify-center w-3/5 mx-auto">
            <Button
              customClasses="w-full rounded-xl font-bold text-[22px] text-white py-4"
              onClick={() => {
                navigate(ROUTES.CLEARTAX);
                trackEvent("cleartax_discount_page_cta_clicked", {
                  cta_for: "proceed_to_ct",
                });
              }}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CopyIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
);

export default FileITRPage;
